import axiosInstance from 'api/axiosInstance';
import { GPDActivity } from 'containers/pages/comments/hooks/useActivities';

async function getActivities(DeliverableId: number): Promise<GPDActivity[]> {
	const data = await axiosInstance.get(
		`/api/cantrackv3/Activities?id=0&SearchKeyword=&Page=1&Take=100&DeliverableId=${DeliverableId}`,
	);
	if (!data || !data.data.Data)
		throw new Error('Failed to fetch timesheet entries');
	if (!data.data.TotalResults || !data.data.Data)
		throw new Error('Invalid data returned from server');

	return data.data.Data;
}

export default getActivities;
